/**
 * analytics.js — the one way the app reports GA4 events.
 *
 * gtag is loaded in public/index.html; it can be missing (ad blockers,
 * react-snap pre-render, tests), so every call is a guarded no-op then.
 *
 * Children use this app: never send names, emails, kid/user ids or free text.
 * Params are catalog ids, subjects and numbers only.
 *
 * Event catalog (params registered as GA4 custom dimensions/metrics):
 *   game_start       game_id, subject, source
 *   game_complete    game_id, subject, source, score, total, stars, pct, duration_sec, level
 *   game_new_set     game_id, source                  (🔀 / replay)
 *   worksheet_print  worksheet_id, subject, source
 *   share            content_type                    (win_card | weekly_card)
 *   guest_signup_click  game_id                      (public /games page "save progress")
 *   sign_up / login  method, role
 *   kid_create       (no params)
 */
export function track(name, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch { /* analytics must never break the app */ }
}
